/** バッテリー低下として表示する残量のしきい値（%）。 */
export const BATTERY_LOW_THRESHOLD_PERCENT = 15;
